import { IAppState } from "@core/store/types"

export const selectAlert = (state:IAppState) => state?.alert?.data
